export const STRINGS = {
  sv: {
    dir: "ltr",
    brand: "Hämta Allt",
    tagline: "Snabb leverans i Norrköping",
    heroSub: "Mat, dagligvaror, apotek, elektronik & tobak — levererat till din dörr.",
    chooseCity: "Välj stad",
    cityHint: "Vi levererar just nu i Norrköping med omnejd.",
    continue: "Fortsätt",
    deliverTo: "Leverera till",
    allCategories: "Alla",
    searchStores: "Sök butik...",
    storesIn: "Butiker",
    noStores: "Inga butiker i denna kategori ännu.",
    rea: "Rea!",
    deliveryIn: "15–30 min",
    fee: "Leverans",
    kr: "kr",
    free: "Gratis",
    open: "Öppna",
    products: "Produkter",
    noProducts: "Inga produkter online ännu — skriv din beställning nedan eller chatta med oss.",
    add: "Lägg till",
    added: "Tillagd i kundvagn",
    cart: "Kundvagn",
    emptyCart: "Din kundvagn är tom",
    note: "Notering",
    notePlaceholder: "T.ex. utan lök, ring vid ankomst...",
    qty: "Antal",
    subtotal: "Delsumma",
    deliveryFee: "Leveransavgift",
    total: "Totalt",
    freeOver: "Gratis leverans över 250 kr",
    freeDelivery: "Fri leverans just nu!",
    toFree: "kr kvar till gratis leverans",
    goCheckout: "Till kassan",
    back: "Tillbaka",
    remove: "Ta bort",
    customTitle: "Egen beställning",
    customPlaceholder: "Skriv vad du vill beställa från denna butik...",
    estAmount: "Uppskattat belopp (kr)",
    addCustom: "Lägg till beställning",
    ageTitle: "Ålderskontroll 18+",
    ageBody: "Denna kategori innehåller tobaksvaror. Du måste vara minst 18 år för att fortsätta.",
    ageConfirm: "Jag är över 18 år",
    ageCancel: "Avbryt",
    checkout: "Kassa",
    recipient: "Mottagare",
    firstName: "Förnamn",
    lastName: "Efternamn",
    street: "Gatuadress",
    postal: "Postnummer",
    cityLabel: "Stad",
    phone: "Telefon",
    email: "E-post (valfritt)",
    orderNote: "Meddelande till kuriren (valfritt)",
    payment: "Betalning",
    cash: "Kontant vid leverans",
    card: "Kort (Stripe)",
    cashDesc: "Betala med kontanter när kuriren kommer.",
    cardDesc: "Säker kortbetalning öppnas när ett bud accepterat beställningen.",
    ageConfirmCheckout: "Jag intygar att jag är över 18 år (tobaksvaror)",
    placeOrder: "Lägg beställning",
    placing: "Skickar...",
    fillRequired: "Fyll i namn, adress och telefon.",
    mustConfirmAge: "Du måste bekräfta att du är över 18 år.",
    orderCreated: "Beställning skapad!",
    tracking: "Följ din beställning",
    orderNr: "Ordernr",
    statusTitle: "Status",
    steps: ["Mottagen", "Accepterad av bud", "På väg", "Levererad"],
    cancelled: "Avbruten",
    yourItems: "Dina varor",
    payWithCard: "Betala med kort nu",
    payAfterAccept: "Kortbetalning öppnas när ett bud accepterat beställningen. Vänta en liten stund.",
    paid: "Betald",
    paymentPending: "Väntar på betalning",
    openingPay: "Öppnar betalning...",
    chat: "Chatta med oss",
    chatTitle: "Support",
    chatPlaceholder: "Skriv ett meddelande...",
    send: "Skicka",
    chatEmpty: "Hej! Hur kan vi hjälpa dig?",
    map: "Karta",
    you: "Du",
    admin: "Hämta Allt",
    backHome: "Till startsidan",
    myOrders: "Mina beställningar",
    viewOrder: "Visa",
    loadError: "Kunde inte ladda butiker",
    loadErrorSub: "Något gick fel vid hämtning av butiker. Kontrollera din anslutning och försök igen.",
    retry: "Försök igen",
    freeDeliveryOver: "Fri leverans på denna order! 🎉",
    outOfStock: "Slut i lager",
  },
  ar: {
    dir: "rtl",
    brand: "Hämta Allt",
    tagline: "توصيل سريع في نورشوبينغ",
    heroSub: "مطاعم، بقالة، صيدلية، إلكترونيات وتبغ — يوصَل إلى بابك.",
    chooseCity: "اختر المدينة",
    cityHint: "نوصّل حالياً في نورشوبينغ وما حولها.",
    continue: "متابعة",
    deliverTo: "التوصيل إلى",
    allCategories: "الكل",
    searchStores: "ابحث عن متجر...",
    storesIn: "المتاجر",
    noStores: "لا توجد متاجر في هذا القسم بعد.",
    rea: "تخفيض!",
    deliveryIn: "١٥–٣٠ دقيقة",
    fee: "التوصيل",
    kr: "كرونة",
    free: "مجاني",
    open: "افتح",
    products: "المنتجات",
    noProducts: "لا توجد منتجات على الإنترنت بعد — اكتب طلبك أدناه أو تحدث معنا.",
    add: "أضِف",
    added: "أُضيف إلى السلة",
    cart: "السلة",
    emptyCart: "سلتك فارغة",
    note: "ملاحظة",
    notePlaceholder: "مثال: بدون بصل، اتصل عند الوصول...",
    qty: "الكمية",
    subtotal: "المجموع الفرعي",
    deliveryFee: "رسوم التوصيل",
    total: "الإجمالي",
    freeOver: "توصيل مجاني فوق ٢٥٠ كرونة",
    freeDelivery: "توصيل مجاني الآن!",
    toFree: "كرونة متبقية للتوصيل المجاني",
    goCheckout: "إتمام الطلب",
    back: "رجوع",
    remove: "حذف",
    customTitle: "طلب مخصص",
    customPlaceholder: "اكتب ما تريد طلبه من هذا المتجر...",
    estAmount: "المبلغ التقديري (كرونة)",
    addCustom: "أضِف الطلب",
    ageTitle: "تأكيد العمر ١٨+",
    ageBody: "هذا القسم يحتوي على منتجات تبغ. يجب أن يكون عمرك ١٨ عاماً على الأقل للمتابعة.",
    ageConfirm: "أؤكد أن عمري فوق ١٨",
    ageCancel: "إلغاء",
    checkout: "الدفع",
    recipient: "المستلم",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    street: "عنوان الشارع",
    postal: "الرمز البريدي",
    cityLabel: "المدينة",
    phone: "الهاتف",
    email: "البريد الإلكتروني (اختياري)",
    orderNote: "رسالة للمندوب (اختياري)",
    payment: "طريقة الدفع",
    cash: "نقداً عند الاستلام",
    card: "بطاقة (Stripe)",
    cashDesc: "ادفع نقداً عند وصول المندوب.",
    cardDesc: "يُفتح الدفع بالبطاقة الآمن عندما يقبل المندوب الطلب.",
    ageConfirmCheckout: "أقرّ بأن عمري فوق ١٨ عاماً (منتجات تبغ)",
    placeOrder: "تأكيد الطلب",
    placing: "جارٍ الإرسال...",
    fillRequired: "يرجى تعبئة الاسم والعنوان والهاتف.",
    mustConfirmAge: "يجب تأكيد أن عمرك فوق ١٨ عاماً.",
    orderCreated: "تم إنشاء الطلب!",
    tracking: "تتبّع طلبك",
    orderNr: "رقم الطلب",
    statusTitle: "الحالة",
    steps: ["تم الاستلام", "قبِلها المندوب", "في الطريق", "تم التوصيل"],
    cancelled: "مُلغى",
    yourItems: "منتجاتك",
    payWithCard: "ادفع بالبطاقة الآن",
    payAfterAccept: "يُفتح الدفع بالبطاقة عندما يقبل المندوب الطلب. يرجى الانتظار قليلاً.",
    paid: "مدفوع",
    paymentPending: "بانتظار الدفع",
    openingPay: "جارٍ فتح الدفع...",
    chat: "تحدث معنا",
    chatTitle: "الدعم",
    chatPlaceholder: "اكتب رسالة...",
    send: "إرسال",
    chatEmpty: "مرحباً! كيف يمكننا مساعدتك؟",
    map: "الخريطة",
    you: "أنت",
    admin: "Hämta Allt",
    backHome: "الصفحة الرئيسية",
    myOrders: "طلباتي",
    viewOrder: "عرض",
    loadError: "تعذّر تحميل المتاجر",
    loadErrorSub: "حدث خطأ أثناء جلب المتاجر. تحقق من اتصالك وحاول مرة أخرى.",
    retry: "حاول مرة أخرى",
    freeDeliveryOver: "توصيل مجاني لهذا الطلب! 🎉",
    outOfStock: "نفد من المخزون",
  },
};
